<template>
  <div class="membership-view fade-in">
    <section class="membership-hero">
      <div class="container">
        <div class="row align-items-center g-5">
          <div class="col-lg-7">
            <span class="badge bg-danger text-uppercase mb-3">Clube de Sangue</span>
            <h1 class="membership-title">Seja Membro Premium</h1>
            <p class="membership-subtitle">
              Expanda as possibilidades da sua crônica com recursos exclusivos pensados para narradores e jogadores que
              querem ir além do básico.
            </p>
            <ul class="list-unstyled membership-highlights">
              <li>
                <i class="bi bi-check-circle-fill"></i>
                Até <strong>5 fichas de personagem</strong> simultâneas para organizar todos os seus Cainitas.
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <strong>Salas privadas no chat</strong> para convidar apenas o seu coterie ou a mesa inteira.
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <strong>Descontos exclusivos</strong> em produtos de parceiros selecionados sempre que novas promoções surgirem.
              </li>
            </ul>
            <button class="btn btn-vampire btn-lg" type="button" @click="$emit('cta')">
              <i class="bi bi-gem me-2"></i>
              {{ ctaLabel }}
            </button>
          </div>
          <div class="col-lg-5">
            <div class="membership-spotlight">
              <div class="spotlight-overlay"></div>
              <div class="spotlight-content">
                <h2>Domine a noite</h2>
                <p>
                  Recursos premium que valorizam sua mesa, facilitam a organização da crônica e entregam novidades antes de
                  todo mundo.
                </p>
                <div class="d-flex flex-column gap-2">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-stars me-2"></i>
                    Novas integrações e ferramentas em desenvolvimento constante.
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-shield-lock me-2"></i>
                    Segurança e controle sobre quem participa das suas histórias.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="membership-details">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <article class="benefit-card h-100">
              <div class="benefit-icon">
                <i class="bi bi-files"></i>
              </div>
              <h3>Biblioteca de Fichas</h3>
              <p>
                Estruture até cinco fichas completas com atributos, disciplinas e histórico para acompanhar cada etapa da
                evolução do personagem.
              </p>
            </article>
          </div>
          <div class="col-lg-4">
            <article class="benefit-card h-100">
              <div class="benefit-icon">
                <i class="bi bi-lock"></i>
              </div>
              <h3>Salas Reservadas</h3>
              <p>
                Crie refúgios digitais para a sua mesa com convites privados, moderação facilitada e registro das decisões
                importantes da crônica.
              </p>
            </article>
          </div>
          <div class="col-lg-4">
            <article class="benefit-card h-100">
              <div class="benefit-icon">
                <i class="bi bi-bag-heart"></i>
              </div>
              <h3>Clube de Vantagens</h3>
              <p>
                Receba cupons exclusivos de parceiros temáticos, colecionáveis e acessórios especiais para enriquecer suas
                sessões presenciais ou on-line.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="membership-plan">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-xl-5">
            <div class="plan-card text-center">
              <span class="badge bg-warning text-dark text-uppercase mb-3">Plano Único</span>
              <h2 class="plan-price">R$ 19,90<span>/mês</span></h2>
              <p class="text-muted">
                Cancelamento a qualquer momento. Sem taxas escondidas. Ideal para narradores que querem controlar cada detalhe
                da noite eterna.
              </p>
              <ul class="list-unstyled plan-features text-start">
                <li>
                  <i class="bi bi-dice-5-fill"></i>
                  Painel de crônicas com até 5 fichas simultâneas.
                </li>
                <li>
                  <i class="bi bi-person-lock"></i>
                  Salas privadas ilimitadas no chat com convites por link.
                </li>
                <li>
                  <i class="bi bi-ticket-detailed"></i>
                  Descontos e mimos exclusivos com parceiros do Mundo das Trevas.
                </li>
                <li>
                  <i class="bi bi-bell"></i>
                  Acesso antecipado a ferramentas e eventos digitais.
                </li>
              </ul>
              <button class="btn btn-vampire btn-lg w-100" type="button" @click="$emit('cta')" :disabled="isPremiumMember">
                <i class="bi bi-credit-card me-2"></i>
                {{ planButtonLabel }}
              </button>
              <p v-if="!isLoggedIn" class="small text-muted mt-3">
                Faça seu cadastro para seguir para o checkout. É rapidinho!
              </p>
              <p v-else-if="isPremiumMember" class="small text-success mt-3">
                Você já desbloqueou todos os benefícios Premium. Obrigado por apoiar a Camarilla!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="membership-roadmap">
      <div class="container">
        <div class="row align-items-center g-4">
          <div class="col-lg-6">
            <h2>Novidades à espreita</h2>
            <p>
              Estamos preparando um painel interno para que a curadoria acompanhe as assinaturas premium sem precisar expor a
              ferramenta publicamente. Ele funcionará como uma intranet segura para liberar benefícios e acompanhar pagamentos
              manualmente.
            </p>
            <p>
              Enquanto o painel não chega, toda solicitação enviada pelo checkout é enviada com segurança para a equipe,
              garantindo que ninguém fique sem acesso às vantagens da corte.
            </p>
          </div>
          <div class="col-lg-6">
            <div class="roadmap-card">
              <h3 class="mb-3">Em desenvolvimento</h3>
              <ul class="list-unstyled roadmap-list">
                <li>
                  <i class="bi bi-kanban"></i>
                  Dashboard privado para aprovar e gerenciar membros premium.
                </li>
                <li>
                  <i class="bi bi-graph-up"></i>
                  Relatórios de pagamento e histórico de upgrades da comunidade.
                </li>
                <li>
                  <i class="bi bi-envelope-check"></i>
                  Fluxos automáticos de boas-vindas e lembretes personalizados.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PremiumMembershipView',
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isPremiumMember: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ctaLabel() {
      if (this.isPremiumMember) {
        return 'Você já é Premium'
      }
      return this.isLoggedIn ? 'Ir para o checkout' : 'Assinar agora'
    },
    planButtonLabel() {
      if (this.isPremiumMember) {
        return 'Benefícios já ativos'
      }
      return this.isLoggedIn ? 'Finalizar assinatura' : 'Criar conta e assinar'
    }
  }
}
</script>

<style scoped>
.membership-view {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.membership-hero {
  padding: 4rem 0 2rem;
}

.membership-title {
  font-size: 3rem;
  font-weight: 700;
  color: var(--vampire-gold);
  text-shadow: 0 0 25px rgba(212, 175, 55, 0.35);
}

.membership-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
}

.membership-highlights li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  margin-bottom: 0.75rem;
}

.membership-highlights i {
  color: var(--vampire-gold);
  font-size: 1.25rem;
}

.membership-spotlight {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background-image: url("https://images.unsplash.com/photo-1500530855697-b586d89ba3ee");

  background-position: center;
  background-size: cover;
  min-height: 360px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.45);
}

.spotlight-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(26, 13, 13, 0.85), rgba(139, 0, 0, 0.8));
}

.spotlight-content {
  position: relative;
  padding: 2.5rem;
  color: #f8f9fa;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.membership-details {
  padding: 2rem 0;
}

.benefit-card {
  background: rgba(26, 13, 13, 0.85);
  border: 1px solid rgba(212, 175, 55, 0.25);
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-6px);
  border-color: var(--vampire-gold);
}

.benefit-card h3 {
  color: var(--vampire-gold);
  margin-bottom: 1rem;
  font-weight: 600;
}

.benefit-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(212, 175, 55, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: var(--vampire-gold);
  margin-bottom: 1.5rem;
}

.membership-plan {
  padding: 2rem 0 0;
}

.plan-card {
  background: rgba(17, 17, 17, 0.92);
  border: 1px solid rgba(212, 175, 55, 0.3);
  border-radius: 24px;
  padding: 2.5rem 2rem;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);
}

.plan-price {
  font-size: 3rem;
  font-weight: 700;
  color: var(--vampire-gold);
}

.plan-price span {
  font-size: 1rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
}

.plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  color: rgba(255, 255, 255, 0.85);
}

.plan-features i {
  color: var(--vampire-gold);
  font-size: 1.1rem;
  margin-top: 0.2rem;
}

.membership-roadmap {
  padding: 0 0 4rem;
}

.membership-roadmap h2 {
  color: var(--vampire-gold);
  margin-bottom: 1.5rem;
}

.roadmap-card {
  background: rgba(26, 13, 13, 0.9);
  border: 1px solid rgba(212, 175, 55, 0.25);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
}

.roadmap-list li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.roadmap-list i {
  color: var(--vampire-gold);
  font-size: 1.2rem;
}

@media (max-width: 991.98px) {
  .membership-title {
    font-size: 2.4rem;
  }

  .membership-view {
    gap: 3rem;
  }
}
</style>
